import { SenecFPPTheme } from "src/styles/fpp-theme/theme.types";

export const senecTabsTheme = (theme: SenecFPPTheme) => {
    return {
        styleOverrides: {
            indicator: {
                backgroundColor: theme.palette.deepBlue.main,
                borderRadius: "20px",
                height: 2,
            },
            root: {
                minHeight: "auto",

                ".MuiTabs-scrollableX .MuiTab-root": {
                    marginRight: 0,
                },

                ".MuiTabScrollButton-root": {
                    position: "absolute",
                    height: "100%",
                    zIndex: 10,
                    transition: "opacity 0.05s",

                    "&:first-child": {
                        background:
                            "linear-gradient(90deg, rgba(255,255,255,1) 0%, rgba(255,255,255,0.8) 60%, rgba(255,255,255,0) 100%)",
                        opacity: "1",
                        left: 0,
                    },

                    "&:last-child": {
                        background:
                            "linear-gradient(270deg, rgba(255,255,255,1) 0%, rgba(255,255,255,0.8) 60%, rgba(255,255,255,0) 100%)",
                        opacity: "1",
                        right: 0,
                    },

                    "&.Mui-disabled": {
                        opacity: "0",
                    },
                },
            },
        },
    };
};
